import FeatureStatus from './FeatureStatusContainer'

export default FeatureStatus
